import React from "react";
import {
  MainWrapper,
  InactiveContent,
  IconStyled,
  InactiveText,
  LockWrapper,
  LockMainWrapper,
  LockWrapperShade,
  ErrorDescription
} from "./styles/Styled";
import { Image } from "../../../services/visualLibraryService";
import { withAppState } from "../../../state";
import { i18n } from "../../../services/i18nService";
import { getDeviceName } from "../../../utils/mobileLiteUtils";
import DefaultChannelImage from "./epgdefaultchannelimage1.png";
import DefaultChannelImageLeft from "./epgdefaultchannelimageleft.png";
import { RTL } from "../../../e2e/utils/constants";

class PlayerPlaceholder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      platFormName: "",
      isImageLoadError: false
    };
    this.appFlow = i18n.getDirection();
  }

  async componentDidMount() {
    await this.getPlatform();
  }

  getPlatform = async () => {
    const deviceName = await getDeviceName();
    if (deviceName) {
      this.setState({
        platFormName: deviceName
      });
    }
  };

  handleError = e => {
    e.target.src = this.appFlow !== RTL ? DefaultChannelImage : DefaultChannelImageLeft;
  };

  render() {
    const { channelImage, isUpComingLinear, isError, errorHeading, errorMessage } = this.props || {};
    const { inActiveSubscriptionName, deviceNotSupported, actionLabel, actionPlanName, inActiveSubscriptionAction } =
      this.props || {};
    const { platFormName } = this.state;
    const imageStyle = { objectFit: "contain", width: "100%", height: "100%" };
    return (
      channelImage && (
        <MainWrapper>
          <img src={channelImage} style={imageStyle} alt="image missing" onError={this.handleError} />
          {!isUpComingLinear && (
            <LockMainWrapper direction={i18n.getDirection()} isError={isError}>
              <LockWrapperShade></LockWrapperShade>
              <LockWrapper>
                <InactiveContent>
                  <IconStyled name={isError || deviceNotSupported ? "epg_player_error" : "lock"} isError={isError} />
                </InactiveContent>
                <InactiveText
                  text={
                    isError && errorHeading
                      ? errorHeading
                      : isError
                      ? `${i18n.get("pages.livePage.error.heading")}`
                      : deviceNotSupported
                      ? `${i18n.get("global.errors.account.unSupportedDeviceError", platFormName)}`
                      : actionLabel === "switchTo"
                      ? `${i18n.get(`pages.brands.switchToCaps`)} ${inActiveSubscriptionName} ${actionPlanName}`
                      : `${i18n.get(`pages.livePage.${inActiveSubscriptionAction}`)} ${inActiveSubscriptionName}`
                  }
                />
                {isError && errorMessage ? (
                  <ErrorDescription text={errorMessage}></ErrorDescription>
                ) : (
                  isError && (
                    <ErrorDescription text={`${i18n.get("pages.livePage.error.description")}`}></ErrorDescription>
                  )
                )}
              </LockWrapper>
            </LockMainWrapper>
          )}
        </MainWrapper>
      )
    );
  }
}

const Component = withAppState(PlayerPlaceholder);
export default Component;
